const filterBlock = require("./filter");
module.exports = function (element) {
    require('jquery-tageditor');
    require('jquery-tageditor/jquery.tag-editor.min');
    require("jquery-ui/ui/widgets/autocomplete");
    require("jquery-ui/ui/widgets/draggable");

    function fonAddBlock(el) {
        let node = $(el)
        let uploadBlock = node.find('.js-fon_upload')
        let uploadInput = node.find('.js-on_upload_file')
        let uploadItemBlock = node.find('.js-fon_upload_item')
        let uploadItemListBlock = node.find('.js-fon_upload_item_list')
        let fonAddRuleLink = node.find('.js-fon_add_rule_link')
        let fonAddRuleBlock = node.find('.js-fon_add_rule_block')
        let fonUploadLimitBlock = node.find('.js-fon_upload_limit')
        let uploadLimit = uploadInput.data('limit')

        let filterBlock = require('./filter')

        let checkLimit = function () {
            if (uploadLimit < 1) {
                uploadBlock.addClass('fon_add__disabled')
                return false
            } else {
                uploadBlock.removeClass('fon_add__disabled')
                fonUploadLimitBlock.text(uploadLimit)
            }
        }

        checkLimit()

        fonAddRuleLink.on('click', function () {
            fonAddRuleBlock.toggleClass('hidden')
            return false
        })

        let checkFile = function (uploadItem, block) {
            let formData = new FormData();
            formData.append('img', uploadItem.file);

            $.ajax({
                url: '/add/check/',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (data) {
                    if (data.status === 'error') {
                        uploadItem.file = null
                        block.children(':first').addClass('fon_add__item__err')
                        block.find('.js-fon_upload_err').html(data.result.message)
                    }
                },
                complete: function () {
                    block.find('.js-fon_upload_item_img').removeClass('fon_add__img_blur')
                    block.find('.js-fon_upload_item_img_loading').addClass('hidden')
                },
            })
        }

        let upload = function (uploadItem, block, button) {
            let blockError = block.find('.js-fon_upload_err')
            let blockLoading = block.find('.js-fon_upload_loading')

            blockLoading.removeClass('hidden')

            let formData = new FormData();
            formData.append('img', uploadItem.file);
            formData.append('tags', uploadItem.tags.join(','));
            formData.append('catalog', uploadItem.catalog);

            $.ajax({
                url: '/add/',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                complete: function () {
                    blockLoading.addClass('hidden')
                    button.prop('disabled', false)
                },
                success: function (data) {
                    if (data.status === 'error') {
                        blockError.html(data.result.message)
                    } else {
                        blockError.html('')
                        let item = data.result
                        block.find('.js-filter-block').remove()
                        block.find('.js-fon_upload_item_img_del').remove()
                        block.find('.js-filter-link').text(item.catalog.name).attr('href', item.catalog.url)

                        block.find('.js-fon_upload_button').remove()
                        block.find('.js-fon_upload_success').attr('href', item.url).removeClass('hidden')

                        let tagBlock = block.find('.js-fon_upload_tags').parent()
                        tagBlock.empty()

                        item.tags.forEach((tag) => {
                            let tagItem = $('<a>', {
                                text: tag.name,
                                href: tag.url,
                                target: '_blank',
                                class: 'fon_add__item__tag'
                            }).appendTo(tagBlock)

                            if (item.tags.at(-1) !== tag) {
                                tagItem.append(' • ')
                            }
                        })

                    }
                },
            })
        }

        let itemCheck = function (uploadItem, button) {
            if (uploadItem.tags.length > 2 && uploadItem.file !== null && uploadItem.catalog) {
                button.prop('disabled', false)
            } else {
                button.prop('disabled', true)
            }
        }

        let uploadFiles = function (files) {
            Array.from(files).slice(0, uploadLimit).forEach(function (file) {
                if (!file.type.startsWith('image/')) {
                    return false
                }

                let uploadItem = {
                    file: file,
                    catalog: '',
                    tags: [],
                }
                let newBlock = uploadItemBlock.clone()

                let button = newBlock.find('.js-fon_upload_button')
                button.on('click', function () {
                    $(this).prop('disabled', true)
                    upload(uploadItem, newBlock, button)
                })

                newBlock.removeClass('hidden')
                newBlock.find('.js-fon_upload_item_img').get(0).src = URL.createObjectURL(file)
                newBlock.find('.js-select-catalog').on('click', function () {
                    uploadItem.catalog = $(this).data('catalog')
                    itemCheck(uploadItem, button)
                    return false
                })

                newBlock.find('.js-fon_upload_item_img_del').on('click', function () {
                    uploadLimit += 1
                    checkLimit()
                    newBlock.remove()
                })

                filterBlock(newBlock)

                let tagEditorBlock = newBlock.find('.js-fon_upload_tags')
                tagEditorBlock.tagEditor({
                    forceLowercase: false,
                    autocomplete: {'source': '/moderator/suggest/tag/', minLength: 3},
                    placeholder: tagEditorBlock.attr('placeholder'),
                    onChange: function (field, editor, tags) {
                        uploadItem.tags = tags
                        itemCheck(uploadItem, button)
                    }
                })

                checkFile(uploadItem, newBlock)

                uploadItemListBlock.append(newBlock)

                uploadLimit -= 1
                checkLimit()
            })
        }

        uploadInput.on('change', function () {
            if (uploadLimit < 1) {
                return false
            }
            uploadFiles(this.files)
        })

        uploadBlock.on('click', function (event) {
            if (uploadLimit < 1) {
                return false
            }
            uploadInput.click()
        })

        uploadBlock.on('dragover', false).on('drop', function (event) {
            if (uploadLimit < 1) {
                return false
            }
            let files = event.originalEvent.dataTransfer.files
            uploadFiles(files)
            return false
        })
    }

    if (!element) {
        throw new Error('Element undefined')
    }

    fonAddBlock(element)
}